import React from 'react';
import Confetti from 'react-confetti';

class GG_confetti extends React.Component {
    render () {
        return (
            <Confetti 
                colors={['#16DFAD', '#FFD700', '#5481C2', '#F04758']}
                confettiSource={ window.innerWidth < 600 ? 
                    {   x: window.innerWidth *0.225, // original was 0.1 
                        y: window.innerHeight *0.15 , 
                        w: window.innerWidth *0.45, 
                        h: window.innerHeight *0.2 
                    } :
                    {   x: window.innerWidth *(0.45),  
                        y: window.innerHeight *0.2, //0.1
                        w: window.innerWidth *0.1,  //0.1
                        h: window.innerHeight *0.2 //0.2 
                    } 
                }
                height={window.innerHeight * 1}
                width={window.innerWidth < 600 ? window.innerWidth * 1 : window.innerWidth * 1}
                numberOfPieces={window.innerWidth < 600 ? 150 : 250}
                gravity={0.4}

                initialVelocityX={window.innerWidth < 600 ? 7 : 12}
                initialVelocityY={window.innerWidth < 600 ? 15 : 12}

                recycle={false}
                tweenDuration={window.innerWidth < 600 ? 2500 : 1750}

                drawShape={ctx => {
                    let max_x = 25;
                    let max_y = 50;
                    let init_x = max_x * 0.1;
                    let end_x = max_x * 0.9;
                    let scale = 0.5;

                    ctx.beginPath();
                    ctx.lineTo( init_x*scale, max_y*scale);
                    ctx.lineTo(end_x*scale, max_y*scale);
                    ctx.lineTo(max_x*scale, 0);
                    ctx.lineTo( 0, 0);
                    ctx.fill();
                }}
            />
            );
        
    }
}

export default GG_confetti;